import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSquare } from "@fortawesome/free-solid-svg-icons";
import RecorderDialog from "../../AttachmentSelection/RecorderDialog";
import AttachmentPreview from "components/AttachmentPreview/AttachmentPreview";

export default function RecordVideo({
  onChange = () => { },
  selectors = ["audio", "image", "video", "screen"],
  type = "video",
  formik,
  showSelectors = true,
  recordedAttachment = null,
  clearRecordedMedia,
}) {
  const [showRecorderDialog, setShowRecorderDialog] = useState(false);
  const [showPreviewDialog, setShowPreviewDialog] = useState(false);

  const recordedAttachmentReceived = (file) => {
    if (!file) {
      return;
    }
    onChange(file);
  };

  return (
    <div className="d-flex justify-content-center attached-media-preview rounded overflow-hidden mb-3 on-web">
      {recordedAttachment && (
        <AttachmentPreview
          attachment={recordedAttachment}
          clearAttachment={clearRecordedMedia}
          commentAttachmentPreview={"peerPreviewAttachment"}
          showPreview={showPreviewDialog}
          setShowPreview={setShowPreviewDialog}
        />
      )}
      {!recordedAttachment && (
        <img
          alt="Video/Audio Recording Preview"
          src="https://images.unsplash.com/photo-1650357133162-33f3d836f198?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=725&q=80"
        />
      )}
      <div className="record-attachment d-flex justify-content-center align-items-center">
        {recordedAttachment && (
          <button
            type="button"
            className="fw-normal pointer"
            onClick={() => setShowPreviewDialog(true)}
          >
            Preview
          </button>
        )}
        <div className="record bg-white-round pointer" onClick={() => setShowRecorderDialog(true)}>
          <FontAwesomeIcon
            icon={faSquare}
            className="text-danger"
          />
        </div>
      </div>
      {showRecorderDialog && (
        <RecorderDialog
          selectors={formik.values.intro_id || formik.values.outro_id ? ["video"] : selectors}
          showRecorderDialog={showRecorderDialog}
          hide={() => setShowRecorderDialog(false)}
          onChange={recordedAttachmentReceived}
          showSelectors={showSelectors}
          type={type}
        />
      )}
    </div>
  );
}
